/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { Button, Flex, IconLoading, Modal } from "@powerledger/ui-component-lib";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";

import { termsAndConditionsSchema } from "@/app/lib/validation";

import { AccountDetailsInput } from "../../types/generated/graphql";
import { Form } from "../form";
import { LegalCheckBoxes } from "../legal-check-boxes";
import { TermsAndConditionsModalProps } from "./terms-and-conditions-modal.types";

export const TermsAndConditionsModalView = ({ handleSubmit, handleCancel }: TermsAndConditionsModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      visible
      sx={{ maxHeight: "inherit", p: 4 }}
      hideCloseButton
      title={t("Accept Terms and Conditions")}
      subtitle={t(
        "Welcome to TraceX! Before you start using the TraceX Marketplace, we kindly ask you to review and accept the TraceX Rules, Terms of Access and Privacy Policy.",
      )}
    >
      <Formik
        initialValues={{
          privacyPolicyAccepted: false,
          termsAccepted: false,
          rulesAcceptedDate: false,
        }}
        onSubmit={handleSubmit}
        validationSchema={termsAndConditionsSchema}
        validateOnMount
      >
        {({ values, handleSubmit, isSubmitting, isValid, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <LegalCheckBoxes
              handleAcknowledgementChange={(name) => setFieldValue(name, !values[name as keyof AccountDetailsInput])}
              isCheckBoxDisabled={() => false}
              showLegalMessage={false}
            />
            <Flex sx={{ justifyContent: "flex-end" }}>
              {isSubmitting ? (
                <IconLoading />
              ) : (
                <Flex sx={{ justifyContent: "flex-end", mt: 4 }}>
                  <Button variant="error" onClick={handleCancel} sx={{ mr: 3, minWidth: 80 }} disabled={isSubmitting}>
                    {t("Cancel")}
                  </Button>
                  <Button variant="primary" onClick={() => handleSubmit()} disabled={isSubmitting || !isValid}>
                    {t("Proceed")}
                  </Button>
                  {isSubmitting && <IconLoading size="small" sx={{ ml: 2 }} />}
                </Flex>
              )}
            </Flex>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
